import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Checkbox } from "./ui/checkbox";
import { Mail, ChevronDown } from "lucide-react";

export function useProjectRecipients(projectId) {
  const [members, setMembers] = useState([]);
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    api.get(`/projects/${projectId}/members`).then((r) => {
      setMembers(r.data);
      setSelected(r.data.map((m) => m.email));
    }).catch(() => {});
  }, [projectId]);
  return { members, selected, setSelected };
}

export default function RecipientSelect({ members, selected, setSelected }) {
  const toggle = (email) =>
    setSelected((prev) => (prev.includes(email) ? prev.filter((e) => e !== email) : [...prev, email]));

  const label =
    selected.length === 0 ? "No recipients" :
    selected.length === members.length ? "All recipients" :
    `${selected.length} recipient${selected.length === 1 ? "" : "s"}`;

  if (members.length === 0) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="recipient-select-trigger"
          className="inline-flex items-center gap-2 border border-[#EBE5E0] bg-white px-3 py-2 text-xs uppercase tracking-wider text-[#5C5651] hover:border-[#A68A6B]">
          <Mail size={14} strokeWidth={1.5} className="text-[#A68A6B]" />
          {label}
          <ChevronDown size={13} strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 rounded-none border-[#EBE5E0] p-0" data-testid="recipient-select-content">
        <p className="px-4 py-2.5 text-[10px] uppercase tracking-[0.18em] text-[#A68A6B] border-b border-[#EBE5E0]">Email recipients</p>
        <div className="py-1">
          {members.map((m) => (
            <label key={m.email} data-testid={`recipient-option-${m.email}`}
              className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-[#F9F8F6]">
              <Checkbox checked={selected.includes(m.email)} onCheckedChange={() => toggle(m.email)}
                className="rounded-none border-[#A68A6B] data-[state=checked]:bg-[#A68A6B] data-[state=checked]:border-[#A68A6B]" />
              <span className="min-w-0">
                <span className="block text-sm text-[#2B2622] truncate">{m.name} <span className="text-[#9b938b] capitalize">· {m.role}</span></span>
                <span className="block text-[11px] text-[#9b938b] truncate">{m.email}</span>
              </span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
